/* eslint-disable no-underscore-dangle */
export default class Enum {
  constructor(items) {
    // this.__items = items
    this.itemMap = items

    /*
    items.forEach(({alias, text, value}) => {
      this[alias] = {text, value}
    })
    */
    this.itemList = Object.entries(items).map(([key, value]) => ({
      alias: key,
      ...value,
    }))
  }

  items() {
    return this.itemList.map(item => ({...item}))
  }

  alias2Text = alias => this.itemMap[alias].text

  alias2Value = alias => this.itemMap[alias].value

  value2Text = value => {
    const result = this.itemList.find(({value: val}) => val === value)
    if (!result) {
      return ''
    }

    return result.text
  }

  text2Value = text => {
    const result = this.itemList.find(({text: txt}) => txt === text)
    if (!result) {
      return null
    }

    return result.value
  }

  value2Alias = value => {
    const result = this.itemList.find(({value: val}) => val === value)
    if (!result) {
      return ''
    }

    return result.alias
  }
}
